import { isElementNode } from 'anodum';
import isEmptyEditableElement from '../../verifiers/is-empty-editable-element';
import getCollapsedSelectionForClipboard from '../get-collapsed-selection-for-clipboard';
import findRootInlineElement from '../find-root-inline-element';
import splitElement from './split-element';
import { BREAK_TAG } from '../../constants/editable-elements';

const insertInline = (elements, collapsedSelectionData) => {
  const { node } = collapsedSelectionData;
  const pasteElements = document.createDocumentFragment();
  pasteElements.append(...elements);
  if (isElementNode(node) && isEmptyEditableElement(node)) {
    const uselessBreak = node.querySelector(BREAK_TAG);
    if (uselessBreak) uselessBreak.remove();

    node.appendChild(pasteElements);
    return getCollapsedSelectionForClipboard(elements);
  }
  const rootEditableInlineElement = findRootInlineElement(node);
  const leftElement = splitElement(rootEditableInlineElement, collapsedSelectionData);
  pasteElements.prepend(leftElement);
  rootEditableInlineElement.parentNode.insertBefore(pasteElements, rootEditableInlineElement);
  return getCollapsedSelectionForClipboard(elements);
};

export default insertInline;
